module.exports = __webpack_public_path__ + "img/_question_mark.dc652de0.svg";